import $ from 'jquery';
import init from '../init.js';
import { getWidth, onScroll } from "../utils/window";
import { dependency } from "../utils/request";
import MarkerClusterer from '@google/markerclusterer';

let mapShown = false;

function showMore(e) {
  e.preventDefault();

  const _THIS = $(this);
  const page = _THIS.attr('data-next-url');

  // more
  const PARENT = _THIS.parent();

  //cards
  const CARDS = _THIS.parent().parent();

  //grid
  const GRID = CARDS.find('> .grid');

  PARENT.addClass('-loading');

  $.get(page, '', function (r) {
    PARENT.remove();
    // CARDS.find('.cards-error').remove();

    const ITEMS = $(r).find('.cards .grid > .cell');
    const NEW_BTN = $(r).find('.cards > .more');

    if (NEW_BTN.length) {
      CARDS.append(NEW_BTN);
    } else {
      CARDS.append(`<div class="more +text-center projects-more"><button id="show">Load more projects +</button></div>`)
    }

    init(ITEMS);

    window.dispatchEvent(new CustomEvent('sw-added-to-list', {
      detail: {
        items: ITEMS.toArray()
      }
    }));

    if (NEW_BTN.length) {
      NEW_BTN.find('#show').on('click', showMore);
      clickShowMore();
    }
    // cardHover($caseStudiesIndex, $newGroup);
  });
}

function clickShowMore() {
  $('#content .content .cards .more').addClass('-loading');

  setTimeout(() => {
    $('#content .content .cards .more #show').trigger('click');
  }, 100);
}

// function checkForReveal(element, reset = false) {
//   const $this = $(element);
//   const isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top;
//   if (isScrolled && !$this.hasClass('is-revealed')) {
//     $this.addClass('is-revealed');
//   } else if (reset && !isScrolled && $this.hasClass('is-revealed')) {
//     $this.removeClass('is-revealed')
//   }
// }

function setFeaturedMarkers(featureData, map, MARKER_FEATURED, bounds) {
  let featureMarkers = [];

  if (featureData.length) {
    featureData.forEach(function (element) {

      const _THIS = element;

      let latLng = {
        lat: parseFloat(_THIS.lat),
        lng: parseFloat(_THIS.lon)
      };

      let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: _THIS.title,
        icon: MARKER_FEATURED,
      });

      marker.addListener('click', function () {
        window.location.href = _THIS.url;
      });

      // bounds.extend(marker.position);

      featureMarkers.push(marker);
    });
  }

  return featureMarkers;
}

function setCommonMarkers(commonData, map, MARKER_COMMON) {
  let commonMarkers = [];

  if (commonData.length) {
    commonData.forEach(function (element) {

      const _THIS = element;

      let latLng = {
        lat: parseFloat(_THIS.lat),
        lng: parseFloat(_THIS.lon)
      };

      let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: _THIS.title,
        icon: MARKER_COMMON,
      });

      commonMarkers.push(marker);
    });
  }

  return commonMarkers;
}

function map() {
  const MAP_STYLE = [
    {
      "featureType": "all",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "weight": "2.00"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#9c9c9c"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#f2f2f2"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bfc3c1"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#46bcec"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#c8d7d4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bfc3c1"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    }
  ];
  const MARKER_ICON_BASE_URL = window.location.origin + '/assets/markers/';
  //feature-marker.svg
  //common-marker.svg

  let googleUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBzggaryJGcBA5Cj-OeSH3KM0tQIa-s8rw';

  if (window.location.origin === 'http://sgsep.dev.local') {
    googleUrl = 'https://maps.googleapis.com/maps/api/js?key=';
  }

  dependency(googleUrl, () => google.maps && window.google.maps).then(function () {

    let fSize = 20 * 1.2;
    let cSize = 7 * 1.5;
    let csSize = 30 * 1.2;
    const MARKER_FEATURED = {
      url: MARKER_ICON_BASE_URL + 'feature-marker.svg',
      scaledSize: new google.maps.Size(fSize, fSize)
    };

    const MARKER_COMMON = {
      url: MARKER_ICON_BASE_URL + 'common-marker.svg',
      scaledSize: new google.maps.Size(cSize, cSize)
    };

    const clusterStyle = [
      {
        url: MARKER_ICON_BASE_URL + 'feature-marker.svg',
        height: csSize,
        width: csSize,
        textColor: 'white',
        textSize: 15
      }
    ];

    let featureMarkers, commonMarkers, featureCluster, commonCluster;

    let mapDoc = document.getElementById('map');
    let mapDataElement = document.getElementById('mapData');

    let featureData = mapDataElement.getAttribute('sw-map-feature');
    let commonData = mapDataElement.getAttribute('sw-map-common');

    let allButton = $('.radio-button #all-projects + label');
    let featureButton = $('.radio-button #feature-projects-only + label');


    let zoomin = $('#zoomin'), zoomout = $('#zoomout');

    featureData = JSON.parse(featureData);
    commonData = JSON.parse(commonData);

    const bounds = new google.maps.LatLngBounds();

    const map = new google.maps.Map(mapDoc, {
      center: new google.maps.LatLng(-25.2744, 133.7751),
      zoom: getWidth() > 700 ? 4 : 4,
      styles: MAP_STYLE,
      disableDefaultUI: true
    });

    featureMarkers = setFeaturedMarkers(featureData, map, MARKER_FEATURED, bounds);
    commonMarkers = setCommonMarkers(commonData, map, MARKER_COMMON);

    if (featureMarkers.length) {
      featureCluster = new MarkerClusterer(map, featureMarkers, {
        styles: clusterStyle,
        gridSize: 30
      });
    }

    // map.fitBounds(bounds);

    allButton.click(function () {
      commonMarkers.forEach(function (element) {
        element.setVisible(true);
      });
    });

    featureButton.click(function () {
      commonMarkers.forEach(function (element) {
        element.setVisible(false);
      });
    });

    zoomin.click(function () {
      let zoom = map.getZoom();
      zoom += 1;
      map.setZoom(zoom);
    });

    zoomout.click(function () {
      let zoom = map.getZoom();
      zoom -= 1;
      map.setZoom(zoom);
    });
  });
}

function checkForReveal(element, reset = false) {
  const $this = $(element);
  return $(window).scrollTop() + $(window).outerHeight() > $this.offset().top;
}

function initialise() {
  // for the load more section
  const SHOW_MORE = $(
    '#content .content .cards .more #show');
  SHOW_MORE.on('click', showMore);

  const mapEl = $('.map');
  if (mapEl.length) {
    onScroll(() => {
      if (checkForReveal(mapEl) && !mapShown) {
        map();
        mapShown = true;
      }
    });
  }

  clickShowMore();
}

export default function projectsPage() {
  const $html = $('html');
  const $scroller = $('html, body');

  $(function () {
    if ($('.projectsIndex').length || $('.sgsLab').length) {
      initialise();
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/pages/projects.js